var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-10 0 1044 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M764 186 q0 10 -7 17.5t-18 7.5h-81l-21 49h19q3 0 6 2t5 5l64 143q10 22 15.5 46t5.5 50q0 45 -16 85q-17 41 -45 72t-66 51t-82 24v87h86q10 0 17 7.5t7 17.5t-7 17.5t-17 7.5h-221q-11 0 -18 -7.5t-7 -17.5t7 -17.5t18 -7.5h86v-87q-44 -4 -83 -24q-38 -20 -66 -51t-44 -72 q-16 -40 -16 -85q0 -26 5 -50t15 -46l57 -126l-36 -44l-56 43q-1 1 -2 1.5t-2 0.5q-2 0 -4 -2t-2 -5v0v-1l27 -123q0 -2 2 -3.5t4 -1.5h133q2 0 4 2t2 4t-0.5 3t-1.5 2l-65 50l40 50h179l28 -68q6 -14 18.5 -22t27.5 -8h81q11 0 18 7t7 17v0zM525 406l39 -97h-118zM397 327 l-48 105h134zM687 432l-55 -123h-15l-50 123h120z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarFill);
export default __webpack_public_path__ + "static/media/bar-fill.18d334657625c8fbbdf3f1fad6f681b1.svg";
export { ForwardRef as ReactComponent };